import React, { useState, useEffect, useRef } from 'react'
import InputMask from 'react-input-mask'
import Spinner from 'react-spinkit'
import Api from '../../../Api'
import { fetchFooterRequested } from '../../../store/footer/action'
import { useDispatch } from 'react-redux'

function escapeRegExp (str) {
  return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
}

function replaceAll (str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace)
}

function getRawPhone (phone) {
  var rawPhone = replaceAll(phone, '(', '')
  rawPhone = replaceAll(rawPhone, ')', '')
  rawPhone = replaceAll(rawPhone, '-', '')
  rawPhone = replaceAll(rawPhone, ' ', '')

  return rawPhone
}

// Keep the phone cooldown when returning to this route within the same page.
const phoneCooldowns = new Map()

const defaultState = {
  loading: false,
  performer: null,
  skill: null,
  phone: null,
  confirmationCode: '',
  stage: 'fetching', // fetching -> initial -> confirmation -> success
  verificationToken: null,
  error: null
}
const ConfirmProLink = (props) => {
  const dispatch = useDispatch()
  const [state, setState] = useState(defaultState)
  const requestInFlight = useRef(false)
  const [retryAt, setRetryAt] = useState(0)
  const [now, setNow] = useState(Date.now())
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timer)
  }, [])
  const retrySeconds = Math.max(0, Math.ceil((retryAt - now) / 1000))

  useEffect(() => {
    setState({
      ...state,
      stage: 'fetching'
    })
    refetch()
  }, [])

  const refetch = () => {
    const hash = props.match.params.hash
    setState({
      ...state,
      loading: true,
      error: null
    })
    Api.getProLink(hash)
      .then((response) => {
        dispatch(fetchFooterRequested({ pid: 'referral_programm', c: response.body.pro_link.user.id }))
        setState({
          ...state,
          loading: false,
          performer: response.body.pro_link.user,
          skill: response.body.pro_link.skill,
          stage: 'initial'
        })
      })
      .catch((error) => {
        setState({
          ...state,
          loading: false
        })
      })
  }
  const handleRefetch = (event) => {
    setState({
      ...state,
      stage: 'fetching'
    })
    refetch()
  }

  const handlePhoneChange = (event) => {
    setRetryAt(phoneCooldowns.get(getRawPhone(event.target.value)) || 0)
    setState({
      ...state,
      phone: event.target.value
    })
  }

  const handlePhoneSubmit = (event) => {
    event.preventDefault()
    if (requestInFlight.current || retrySeconds > 0) return
    if (state.phone === null || state.phone === undefined) {
      event.preventDefault()
      return
    }

    const rawPhone = getRawPhone(state.phone)
    if (rawPhone.length < 12) {
      event.preventDefault()
      return
    }

    setState({
      ...state,
      loading: true,
      error: null
    })
    requestInFlight.current = true
    Api.requestPhoneCode({ phone: rawPhone })
      .then((response) => {
        const seconds = Number(response.body.retry_after) || 60
        const deadline = Date.now() + seconds * 1000
        phoneCooldowns.set(rawPhone, deadline)
        setNow(Date.now())
        setRetryAt(deadline)
        setState({
          ...state,
          loading: false,
          verificationToken: response.body.verification_token,
          confirmationCode: '',
          stage: 'confirmation'
        })
      })
      .catch((error) => {
        if (error.status === 429) {
          const seconds = Math.max(1, Number(error.response && error.response.body && error.response.body.retry_after) || 60)
          const deadline = Date.now() + seconds * 1000
          phoneCooldowns.set(rawPhone, deadline)
          setNow(Date.now())
          setRetryAt(deadline)
          setState({ ...state, loading: false, error: null })
          return
        }
        setState({
          ...state,
          loading: false,
          error: error.response && error.response.body && error.response.body.error_message
            ? error.response.body.error_message
            : 'Не удалось отправить код. Проверьте номер и попробуйте позже.'
        })
      })
      .finally(() => { requestInFlight.current = false })

    event.preventDefault()
  }

  const handleCodeChange = (event) => {
    setState({
      ...state,
      confirmationCode: event.target.value
    })
  }

  const handleCodeSubmit = (event) => {
    event.preventDefault()
    if (requestInFlight.current) return
    if (state.confirmationCode === null || state.confirmationCode === undefined) {
      event.preventDefault()
      return
    }

    const rawPhone = getRawPhone(state.phone)
    const confirmationCode = state.confirmationCode
    const verificationToken = state.verificationToken

    setState({
      ...state,
      loading: true,
      error: null
    })
    requestInFlight.current = true
    Api.confirmPhoneCode({
      phone: rawPhone,
      code: confirmationCode,
      verificationToken: verificationToken
    })
      .then((response) => {
        setState({
          ...state,
          loading: false
        })
        return confirm()
      })
      .catch((error) => {
        var errorMessage = null

        if (error.status === 404 || error.status === 401) {
          errorMessage = 'Убедитесь в правильности введенного кода!'
        } else {
          errorMessage = 'Не удалось подтвердить код. Перезагрузите страницу и попробуйте еще раз!'
        }

        setState({
          ...state,
          loading: false,
          error: errorMessage
        })
      })
      .finally(() => { requestInFlight.current = false })

    event.preventDefault()
  }

  const confirm = () => {
    const hash = props.match.params.hash

    setState({
      ...state,
      loading: true,
      error: null
    })
    return Api.confirmProLink(hash)
      .then((response) => {
        setState({
          ...state,
          loading: false,
          stage: 'success'
        })
      })
      .catch((error) => {
        var errorMessage = null
        if (error.status === 409) {
          errorMessage = 'Спасибо, но Вы уже рекомендовали этого профи!'
        } else if (error.status === 422) {
          errorMessage = 'Вы не можете рекомендовать самого себя!'
        } else {
          errorMessage = 'Не удалось рекомендовать профи. Перезагрузите страницу и попробуйте еще раз!'
        }

        setState({
          ...state,
          loading: false,
          error: errorMessage
        })
      })
  }

  return (
    <div>
      {
        state.loading &&
        <div>
          <Spinner name="circle" className="spinner" fadeIn="quarter" color="#3897dc"/>
          <div className="overlay">
          </div>
        </div>
      }
      {
        state.stage === 'fetching' &&

        <div>
          <br/>
          {
            state.loading
              ?
              <p className={'text-center'}>Загружается информация о профи...</p>
              :
              <div>
                <p className={'text-center'}>Информация о профи не найдена :-(</p>
                <button className={'btn btn-lg btn-primary btn-block'} onClick={handleRefetch}>Попробовать еще
                  раз
                </button>
              </div>
          }
        </div>
      }
      {
        state.stage === 'initial' &&

        <form className={'sarafan-form'} onSubmit={handlePhoneSubmit}>
          <p className="mb-3 text-center font-weight-normal">
            Порекомендуйте <b>{state.performer.display_name}</b> в категории <b>{state.skill.name}</b></p>
          <label htmlFor="inputPhone">Введите свой номер телефона</label>
          <InputMask
            mask="+7 (999) 999-99-99"
            maskChar={null}
            type="tel"
            disabled={state.loading}
            id="inputPhone"
            className="form-control"
            placeholder="Телефон"
            onChange={handlePhoneChange}
            required
          />
          <br/>
          <button className={'btn btn-lg btn-primary btn-block'} type="submit" disabled={state.loading || retrySeconds > 0} aria-busy={state.loading}>
            {retrySeconds > 0 ? `Новый код через ${retrySeconds} с` : 'Рекомендовать'}
          </button>
        </form>
      }
      {
        state.stage === 'confirmation' &&

        <form className={'sarafan-form'} onSubmit={handleCodeSubmit}>
          <p className="mb-3 text-center font-weight-normal">
            Код для номера <b>{state.phone}</b> отправлен {Api.phoneAuthChannel === 'telegram' ? 'в Telegram от Verification Codes' : 'по SMS'}.</p>
          <label htmlFor="inputCode">Введите четыре цифры кода</label>
          <InputMask
            mask="9999"
            maskChar={null}
            disabled={state.loading}
            id="inputCode"
            className="form-control"
            placeholder={Api.phoneAuthChannel === 'telegram' ? 'Код из Telegram' : 'Код из SMS'}
            autoComplete="one-time-code"
            onChange={handleCodeChange}
            pattern="[0-9]*"
            inputMode="numeric"
            required
          />
          <br/>
          <button className={'btn btn-lg btn-primary btn-block'} type="submit" disabled={state.loading || state.confirmationCode.length !== 4}>Подтвердить</button>
          <button className="btn btn-link btn-block" type="button" disabled={state.loading || retrySeconds > 0}
            onClick={handlePhoneSubmit}>
            {retrySeconds > 0 ? `Повторить через ${retrySeconds} с` : 'Отправить код ещё раз'}
          </button>
          <button className="btn btn-link btn-block" type="button" disabled={state.loading}
            onClick={() => setState({ ...state, stage: 'initial', confirmationCode: '', verificationToken: null, error: null })}>
            Изменить номер
          </button>
        </form>
      }
      {
        state.stage === 'success' &&

        <div className={'text-center'}>
          <h3>Спасибо! Ваша рекомендация учтена!</h3>
          <p>А Вы уже скачали Сарафан?</p>
        </div>
      }
      {
        state.error &&
        <div className="alert alert-danger">
          <strong>Ошибка!</strong> {state.error}
        </div>

      }
    </div>
  )
}

export default ConfirmProLink



// WEBPACK FOOTER //
// ./src/App/component/ConfirmProLink/index.jsx